<div class="role-selector-popup" [class.open]="isOpen()">
  <div class="popup-header">
    <h5 class="mb-0">Select Application Role</h5>
    <button class="btn-close" (click)="onClose()">
      <i antIcon type="close" theme="outline"></i>
    </button>
  </div>
  
  <div class="popup-content">
    <div class="roles-grid">
      @for (role of roles; track role.id) {
        <div class="role-card" (click)="onRoleSelect(role)">
          <div class="role-icon">
            <i antIcon [type]="getRoleIcon(role.name)" theme="outline"></i>
          </div>
          <h6 class="role-title">{{ role.displayName }}</h6>
        </div>
      }
    </div>
  </div>
</div>

<div class="role-selector-overlay" [class.show]="isOpen()" (click)="onClose()"></div>